<template>
	<div id="app">
		<main class="main-content position-relative max-height-vh-100 h-100">
			<router-view></router-view>
		</main>
	</div>
</template>

<script>
export default {
  name: 'App',
}
</script>

